import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SimpleLayout } from '@infotrack/zenith-ui';

import { QueryClientProvider } from '@/app/providers/queryClientProvider';
import { FeatureFlagsProvider } from '@/app/providers/featureFlagsProvider';
import Routes from '@/app/routing/Routes';
import { BASE_PATH } from '@/app/config/appConfig';
import { NavigationMenu } from '@/shared/components/navigation';

const App: React.FC = () => {
  return (
    <BrowserRouter basename={BASE_PATH}>
      <QueryClientProvider>
        <FeatureFlagsProvider>
          <SimpleLayout
            region="AU"
            applicationName="iTopFive"
            basename={BASE_PATH}
            footerEnabled={false}
            bodyPadding="0"
            headerContent={<NavigationMenu />}
          >
            <Routes />
          </SimpleLayout>
        </FeatureFlagsProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
